// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "a6f6666aca34";
export const BUILD_VERSION_NUMBER = 66;
